<div class="banner-wrapper" [class.promo-image]="entityHasPromoImage" *ngIf="!loading">
  <ng-container *ngIf="userFollowsEntity || userDismissedLogin || (displayedInWebView && !userLoggedIn); else followContainer">
    <a [href]="entityLink">
      <ng-container *ngIf="entityHasPromoImage; else entityBanner">
        <img [src]="entityPromoImages.linkImage" alt="Seite öffnen">
      </ng-container>
    </a>
  </ng-container>
  <ng-template #followContainer>
    <div class="follow-wrapper">
      <a [href]="entityLink">
        <ng-container *ngIf="entityHasPromoImage; else entityBanner">
          <img *ngIf="entityPromoImages" [src]="entityPromoImages.followImage" alt="Folgen">
        </ng-container>
      </a>
      <button (click)="followButtonClick()" mat-button class="follow-button">Folgen</button>
    </div>
  </ng-template>
</div>

<ng-template #entityBanner>
  <div class="entity-info" *ngIf="entity">
    <img [src]="entity.pictures | imageUrlBySubtype" [alt]="entity.name">
    <span>{{entity.name}}</span>
  </div>
</ng-template>
